// @flow
import connectWebActions from 'fg-frontend/src/webComponents/connectWebActions';
import { connectWebComponents } from 'fg-frontend/src/webComponents/decorate';
import autoTitleLinksWithBlankTarget from 'fg-frontend/src/components/autoTitleLinksWithBlankTarget';
import safeBlankLinks from 'fg-frontend/src/components/safeBlankLinks';
// import cookiesPolicy from 'fg-frontend/components/CookiesPolicy/index';
import cookiesPolicy from './components/CookiesPolicy/index';

import configureWebComponents from './configureWebComponents';
import configureWebActions from './configureWebActions';
// import phoneLink from 'fg-frontend/components/PhoneLink';
import 'fg-frontend/ramjet/liveValidation';
// import 'bootstrap/collapse'; TODO - use this path if using BS4 bootstrap/js/dist/collapse

cookiesPolicy({
  imgSrc: '/img/cookie-policy/cookie.png',
  disableRwdImg: false,
  messages: {
    cs: {
      perex: 'Tento web používá k poskytování funkcí sociálních médií a analýze návštěvnosti soubory cookies. Kliknutím na&nbsp;tlačítko „Povolit všechna cookies“ souhlasíte s ukládáním a používáním souborů cookies. Detailní informace o&nbsp;cookies <a class="cookies-policy__link" target="_blank" href="https://www.fg.cz/cs/informace-o-cookies">naleznete zde</a>.',
    },
  },
  settingsMessages: {
    cs: {
      perex: 'Zde si můžete nastavit, jaké soubory cookies budeme zpracovávat. Více informací najdete na stránce <a class="cookies-settings__link" target="_blank" href="https://www.fg.cz/cs/informace-o-cookies">Informace o cookies.</a>',
    },
  },
});
connectWebComponents(configureWebComponents);
connectWebActions(configureWebActions, ['keyup']);
autoTitleLinksWithBlankTarget();
// phoneLink();

// Mastaveni atributu 'noopener' vsem target="_blank" odkazum, ktere ho nemaji
safeBlankLinks();



// WEBPACK FOOTER //
// ./fe/web-career/src/js/configureWeb.js